import { useMutation, useQuery } from "@tanstack/react-query"
import { ISurvey, PatientsSurveysSubmissionPostBody } from "../types/types"
import { apiFetchProtected } from "../utils/api"

const fecthSurveys = async (): Promise<Array<ISurvey>> =>
  apiFetchProtected<Array<ISurvey>>("/surveys", {}).then((data) => {
    return data
  })

const useSurveys = <TData = Array<ISurvey>>(
  select?: (data: Array<ISurvey>) => TData
) => {
  return useQuery({
    queryKey: ["surveys"],
    queryFn: () => fecthSurveys(),
    select
  })
}

const usePostPatientSurveySubmission = (
  patient_survey_id: number | undefined
) => {
  return useMutation({
    mutationFn: (patientSurveySubmission: PatientsSurveysSubmissionPostBody) =>
      apiFetchProtected(
        `/practitioners/patient_surveys/${patient_survey_id}/submission`,
        {
          method: "POST",
          body: patientSurveySubmission
        }
      ),
    onError: (error) => {
      console.error("Error:", error)
    },
    onSuccess: (data, variables) => {
      return
    }
  })
}

const usePatchPatientSurveySubmission = (
  patient_survey_id: number | undefined
) => {
  return useMutation({
    mutationFn: (patientSurveySubmission: PatientsSurveysSubmissionPostBody) =>
      apiFetchProtected(
        `/practitioners/patient_surveys/${patient_survey_id}/submission`,
        {
          method: "PATCH",
          body: patientSurveySubmission
        }
      ),
    onError: (error) => {
      console.error("Error:", error)
    },
    onSuccess: (data, variables) => {
      return
    }
  })
}

export {
  useSurveys,
  usePostPatientSurveySubmission,
  usePatchPatientSurveySubmission
}
